import React from "react";
import "./HeaderBar.css";
import LexWorkplaceLogo from "../svg/LexWorkplaceLogo";

import { DropDownButton } from "./DropDownButton";
import {
	FavoriteDocsDropdown,
	RecentItemsDropdown,
} from "./MultiColumnDropdown";
import NewItemDropdown from "./NewItemDropdown";
import WhatsNewDropdown from "./WhatsNewDropdown";

import { NavLink, useLocation } from "react-router-dom";
import { withRouter } from "../utilities/withRouter";
import { connect } from "react-redux";

import { updateWhatsNewDropdownLastHashViewed } from "../actions/browserLocalstorageActions";
import { resetTableColumnWidths } from "../actions/tableSortingActions";
import { HOMEPAGE_TABLE_IDS } from "./Homepage";

import SearchBoxWrapper from "./SearchBox/SearchBox";
import DeveloperOverrides from "./Developer/DeveloperOverrides";
import { settingsRoutes } from "../config/routes";
import { IconUserCircle } from "@tabler/icons-react";
import buildData from "../buildData/buildData";

const DropdownWithRouter = withRouter(DropDownButton);

// Helper component for "LexWorkplace by Uptime Legal" text
const LexWorkplaceTitle = () => (
	<div className="lexTitle">
		<div
			style={{
				lineHeight: "20px",
				fontSize: "20px",
			}}
		>
			LexWorkplace
		</div>
		<div
			style={{
				lineHeight: "12px",
				fontSize: "12px",
			}}
		>
			By Uptime Legal
		</div>
	</div>
);

// Base HeaderBar component
const HeaderBar = ({ linkTo, stuffToRight, mobileToggle }) => {
	const logoContent = (
		<div className="lexworkplace-logo-wrapper">
			<LexWorkplaceLogo />
		</div>
	);

	const handleLogoClick = mobileToggle
		? (e) => {
				if (window.matchMedia("(max-width: 767px)").matches) {
					e.preventDefault();
					mobileToggle();
				}
			}
		: undefined;

	return (
		<div className="HeaderBar">
			<div style={{ marginLeft: 21, marginRight: 8 }}>
				<NavLink to={linkTo || "/"} onClick={handleLogoClick}>
					{logoContent}
				</NavLink>
			</div>
			{stuffToRight}
		</div>
	);
};

// Authenticated user header
const AuthenticatedUserHeaderUnconnected = (props) => {
	const isHomepage = useLocation().pathname === "/";
	const stuffToRight = (
		<>
			<div>
				<SearchBoxWrapper />
			</div>
			<div>
				<div className="headerLeftButtons" id="HeaderNewDropdown">
					<NewItemDropdown />
				</div>
				<div className="headerLeftButtons">
					<RecentItemsDropdown title="Recent" noIcon />
				</div>
				<div className="headerLeftButtons">
					<FavoriteDocsDropdown title="Favorite" noIcon />
				</div>
				<div className="headerLeftButtons">
					<WhatsNewDropdown
						whatsNewDropdownLastHashViewed={
							props.whatsNewDropdownLastHashViewed
						}
						updateWhatsNewDropdownLastHashViewed={
							props.updateWhatsNewDropdownLastHashViewed
						}
						whatsNewItems={props.whatsNewItems}
						whatsNewItemsHash={props.whatsNewItemsHash}
					/>
				</div>
			</div>
			<div style={{ marginLeft: "auto" }}>
				<div>
					<DeveloperOverrides />
				</div>
				<div>
					<DropdownWithRouter
						className="IconDropDown HeaderUserDropDown"
						title={props.userDisplayName}
						iconComponent={
							<IconUserCircle
								size={36}
								style={{ verticalAlign: "middle" }}
							/>
						}
						menuItems={[
							{
								text: `Region: ${props.userRegion}`,
								type: "userRegionFlag",
								region: props.userRegion,
							},
							{
								text: `Version ${buildData.buildNumber}`,
								type: "label",
							},
							{ divider: true },
							props.showDeveloperOptions
								? {
										text: "Developer Information",
										href: "/about",
									}
								: null,
							{
								text: settingsRoutes.MY_PROFILE.label,
								href: settingsRoutes.MY_PROFILE.href,
							},
							{ text: "Settings", href: "/settings" },
							{ divider: true },
							...(isHomepage
								? [
										{
											text: "Reset Column Widths",
											onSelect: () =>
												Object.values(
													HOMEPAGE_TABLE_IDS
												).forEach(
													props.resetTableColumnWidths
												),
										},
										{ divider: true },
									]
								: []),
							{ text: "Log Out", href: "/logout" },
						]}
						pullRight
					/>
				</div>
			</div>
		</>
	);

	return (
		<HeaderBar
			linkTo="/"
			stuffToRight={stuffToRight}
			mobileToggle={props.mobileToggle}
		/>
	);
};

const AuthenticatedUserHeader = connect(
	(state) => {
		return {
			userDisplayName: state.user.userDisplayName,
			whatsNewDropdownLastHashViewed:
				state.browserLocalstorage.whatsNewDropdownLastHashViewed,
			whatsNewItems: state.whatsNew.items,
			whatsNewItemsHash: state.whatsNew.itemsHash,
			userRegion: state?.user?.userRegion || "??????",
			showDeveloperOptions: state.user.showDeveloperOptions,
		};
	},
	{
		updateWhatsNewDropdownLastHashViewed,
		resetTableColumnWidths,
	}
)(AuthenticatedUserHeaderUnconnected);

// Unauthenticated user header
const UnauthenticatedUserHeader = () => {
	const stuffToRight = (
		<>
			<div>
				<LexWorkplaceTitle />
			</div>
			<div className="learnMoreSection">
				<a id="learnMoreLink" href="https://LexWorkplace.com">
					Learn More
				</a>
				<span> about</span>
				<span> LexWorkplace</span>
			</div>
		</>
	);

	return <HeaderBar linkTo="/login" stuffToRight={stuffToRight} />;
};

// Error page header
const ErrorHeader = () => {
	const stuffToRight = (
		<>
			<div>
				<LexWorkplaceTitle />
			</div>
		</>
	);

	return <HeaderBar stuffToRight={stuffToRight} />;
};

export { AuthenticatedUserHeader, UnauthenticatedUserHeader, ErrorHeader };
